import * as React from "react";

import * as Sentry from "@sentry/nextjs";
import Cookies from "js-cookie";
import { useRouter } from "next/router";
import { useSession, signIn } from "next-auth/react";
import useSWR from "swr";

import { Email } from "src/lib/email";

const Auth = ({ children }) => {
  const { status } = useSession();

  const fetcher = (url) => fetch(url).then((r) => r.json());
  const { data: session, isValidating } = useSWR<Session>("/api/auth/session", fetcher);
  const isLoading = status === "loading" || (!session && isValidating);
  const router = useRouter();

  React.useEffect(() => {
    if (isLoading) return; // Do nothing while loading

    const d = Date.now();
    if (!session?.accessToken || d >= Date.parse(session?.expires)) {
      router.push("/auth/signin?msg=Session missing/expired. Please login.");
      return;
    }

    if (session?.error === "RefreshAccessTokenError") {
      const email = new Email(Cookies.get("email"));
      signIn(email.getDomain()); // Force sign in to hopefully resolve error
      return;
    }
  }, [isLoading, session, router]);

  if (!isLoading && !session) {
    Sentry.captureMessage("Failed to get access token, unable to establish session");

    return <div className="centered-disp">Failed to authenticate. Try refreshing page.</div>;
  }

  return children;
};

export default Auth;
